module.exports = __webpack_public_path__ + "static/47-3a794a0c956489a3a869b68588c831a2.png";